import moment from 'moment'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { v4 as uuidv4 } from 'uuid'
import { NoteItem } from '../../NoteItem/NoteItem'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getProviderName = (authorData, isAddendum) =>
  `${isAddendum ? 'Addendum - ' : ''}${authorData?.Prefix ? `${authorData?.Prefix} ` : ''}${
    authorData?.FirstName
  } ${authorData?.LastName}${authorData?.Suffix ? ` ${authorData?.Suffix}` : ''}`

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const NotesItemsList = ({ notesList, emptyText }) => {
  if (!notesList.length) {
    return <div className='prescriptions-section-text prescriptions-section-no-prescriptions-tile'>{emptyText}</div>
  }

  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  return notesList.map(({ Author, IsAddendum, DateTime, Message }, idx) => (
    <NoteItem
      key={uuidv4()}
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      id={uuidv4()}
      providerName={getProviderName(Author, IsAddendum)}
      dateTime={moment(DateTime).format('MMM DD YYYY, h:mma')}
      noteValue={Message}
      isTheLast={notesList.length - 1 === idx}
    />
  ))
}
